// src/firebase-config.js

import { initializeApp } from "firebase/app"

// Your Firebase configuration from the SDK
const firebaseConfig = {
  apiKey: "AIzaSyCKZ-V8KQ8aGyGrWgPAY3mEwNjXodAQX50",
  authDomain: "pushnotif-982e1.firebaseapp.com",
  projectId: "pushnotif-982e1",
  storageBucket: "pushnotif-982e1.firebasestorage.app",
  messagingSenderId: "791639354356",
  appId: "1:791639354356:web:7c3f967d314a7c0c9367a1",
  measurementId: "G-XY8JGED328"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export default app
